/**
 * WEM Integration Service
 * Haal WEM dossiers op
 */

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export interface WemClient {
  clientId: string;
  name: string;
}

class WemService {
  /**
   * Haal WEM dossiers op voor de ingelogde gebruiker
   */
  async getClients(accessToken: string): Promise<WemClient[]> {
    console.log('🔍 Fetching WEM clients...');

    try {
      const response = await fetch(`${API_BASE_URL}/wem/clients`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        console.error('❌ WEM API error:', response.status);
        return [];
      }

      const data = await response.json();
      
      if (!data.configured) {
        console.log('ℹ️ WEM not configured - skipping');
        return [];
      }
      
      console.log('✅ WEM clients retrieved:', data.clients?.length || 0);
      
      return data.clients || [];
    } catch (error) {
      console.error('💥 Error fetching WEM clients:', error);
      return []; // Return empty array on error - niet blokkeren
    }
  }
}

export const wemService = new WemService();